import { createFileRoute } from '@tanstack/react-router'

import { loadChartRedirect } from '@/screens/chart/ChartRedirect.loader'

/**
 * `/chart` — the sidebar's "Chart" row with no symbol in view. See
 * `screens/brokers/ByStockRedirect.tsx` for why `component` never renders on a
 * real visit.
 */
export const Route = createFileRoute('/_workspace/chart')({
  loader: loadChartRedirect,
  component: () => null,
})
